import { useEffect, useState } from 'react';
import Toast from './Toast';
import { TOAST_EVENT, type ToastEvent, type ToastType } from '../../utils/toast';

interface ToastItem {
  id: string;
  message: string;
  type: ToastType;
}

/** Mounts once in App and listens for global toast events from the API interceptor */
export default function GlobalToast() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    const handler = (e: Event) => {
      const { message, type } = (e as CustomEvent<ToastEvent>).detail;
      setToasts((prev) => {
        // Prevent duplicate toasts with the exact same message and type from stacking
        if (prev.some((t) => t.message === message && t.type === type)) {
          return prev;
        }
        const id = `${Date.now()}-${Math.random().toString(36).substring(2, 7)}`;
        const next = [...prev, { id, message, type }];
        return next.length > 2 ? next.slice(-2) : next;
      });
    };
    window.addEventListener(TOAST_EVENT, handler);
    return () => window.removeEventListener(TOAST_EVENT, handler);
  }, []);

  const dismiss = (id: string) => setToasts((t) => t.filter((x) => x.id !== id));

  return (
    <>
      {toasts.map((t) => (
        <Toast key={t.id} message={t.message} type={t.type} onClose={() => dismiss(t.id)} />
      ))}
    </>
  );
}
